import useAsync from "@kikoff/hooks/src/useAsync";

import styles from "./ExpressiveIcon.module.scss";

declare namespace ExpressiveIcon {
  type Name =
    | "bill-pay"
    | "calendar"
    | "cashback"
    | "celebrate"
    | "credit-report"
    | "deposit"
    | "fraud-protection"
    | "gift-with-bow"
    | "kikoff-card"
    | "kikoff-credit"
    | "kikoff-store"
    | "location"
    | "mailbox"
    | "move-direct-deposit"
    | "my-account"
    | "my-order"
    | "privacy"
    | "rocket"
    | "safe"
    | "savings"
    | "security"
    | "settings"
    | "starter-loan"
    | "statements"
    | "withdraw";

  interface Props {
    name: Name;
    asBlock?: boolean;
    size?: React.CSSProperties["width"];
  }
}
export default ExpressiveIcon;
function ExpressiveIcon({ name, asBlock, size = 32 }: ExpressiveIcon.Props) {
  const src = useAsync(() => import(`./images/${name}.svg`))?.default.src;

  return (
    <div
      className={styles["expressive-icon"]}
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        maxWidth: size,
        maxHeight: size,
        display: asBlock ? "block" : "inline-block",
      }}
    >
      <div className={styles.fallback} />
      {src && <img src={src} />}
    </div>
  );
}
